import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { AppleButton, FacebookButton, GoogleButton } from 'components/Button';
import { Divider } from 'components/Divider';
import {
  Form,
  FormUsageContext,
  GeneralError,
  InputField,
  RecaptchaField,
  SubmitButton,
} from 'components/Form';
import { Link, RouterLink } from 'components/Link';
import { BodySmall } from 'components/Text/BodySmall';
import { trackClicked } from 'utils/analytics/track/trackClicked';

type Props = {
  analyticsTitle: string;
  usageContext: FormUsageContext;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValues: Record<string, any>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showLoginModal: (...args: Array<any>) => any;
  getLoginUrlAndState: (email?: string) => {
    to: string;
    state: Record<string, unknown>;
  };
  getThirdPartyLoginUrl: (
    arg0: 'facebook' | 'google' | 'apple',
  ) => Promise<string> | string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loginOverrideFn?: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (...args: Array<any>) => any;
  compactView?: boolean;
  hideLoginBlock?: boolean;
  customButtonText?: boolean;
};

export function EmailSignupForm({
  analyticsTitle,
  usageContext,
  initialValues,
  showLoginModal,
  getLoginUrlAndState,
  getThirdPartyLoginUrl,
  loginOverrideFn,
  onSubmit,
  compactView,
  hideLoginBlock,
  customButtonText,
}: Props) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/function-component-definition, react/no-unstable-nested-components
  const LoginLink = ({
    email,
    ...props
  }: {
    children?: ReactNode;
    email?: string;
  }) => {
    if (loginOverrideFn) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            trackClicked('Log In');
            loginOverrideFn();
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      );
    }

    if (usageContext === 'modal' && showLoginModal) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            trackClicked('Log In');
            showLoginModal(email);
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      );
    }
    const loginUrlAndState = getLoginUrlAndState(email);
    return (
      <RouterLink
        to={loginUrlAndState.to}
        state={loginUrlAndState.state}
        onClick={() => {
          trackClicked('Log In');
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  };

  return (
    <Form
      analyticsTitle={analyticsTitle}
      usageContext={usageContext}
      data-qa-id="signup-email-form"
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ values: { email } }) => (
        <>
          {!hideLoginBlock && (
            <Box mb={[16, null, 16]}>
              <BodySmall textAlign="center">
                {getText('Already have an account?')}{' '}
                <LoginLink email={email}>{getText('Log in')}</LoginLink>
              </BodySmall>
            </Box>
          )}
          <Box display="flex" flexDirection="column" mb={4} mt="-6px" mx="-6px">
            <Box m="6px">
              <GoogleButton
                onClick={async (e) => {
                  e.preventDefault();
                  const url = await getThirdPartyLoginUrl('google');
                  // @ts-expect-error TS(2322): Type 'string' is not assignable to type '(string |... Remove this comment to see the full error message
                  window.location = url;
                }}
                data-qa-id="google-oauth"
              />
            </Box>
            <Box m="6px">
              <FacebookButton
                onClick={async (e) => {
                  e.preventDefault();
                  const url = await getThirdPartyLoginUrl('facebook');
                  // @ts-expect-error TS(2322): Type 'string' is not assignable to type '(string |... Remove this comment to see the full error message
                  window.location = url;
                }}
                data-qa-id="facebook-oauth"
              />
            </Box>
            <Box m="6px">
              <AppleButton
                onClick={async (e) => {
                  e.preventDefault();
                  const url = await getThirdPartyLoginUrl('apple');
                  // @ts-expect-error TS(2322): Type 'string' is not assignable to type '(string |... Remove this comment to see the full error message
                  window.location = url;
                }}
                data-qa-id="apple-oauth"
              />
            </Box>
          </Box>

          {!compactView && <Divider marginTop={24} marginBottom={24} />}

          <GeneralError />

          <InputField
            name="email"
            label={getText('Email')}
            type="email"
            placeholder={getText('casey.smith@example.com')}
          />

          {(!compactView || email) && <RecaptchaField />}

          <Box mt={[16, null, 40]} display="flex" justifyContent="flex-end">
            <SubmitButton fullWidth size="large">
              {customButtonText || getText('Sign up')}
            </SubmitButton>
          </Box>
        </>
      )}
    />
  );
}
